import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import Navbar from '../Navbar/Navbar';
import classes from './AppContainer.styles.less';
export default function AppContainer({ children }) {
    const [theme] = useTheme();
    return (_jsxs("div", { className: cx(classes.appContainer, classes[theme]), children: [_jsx(Navbar, {}), _jsx("main", { className: classes.main, children: children })] }));
}
